import { z } from "zod";

export const qrScanProcessSchema = z.object({
  id: z.string().uuid(),
  MaterialIDs: z.array(z.number())
});
export type qrScanProcessPayload = z.infer<typeof qrScanProcessSchema>;